import { DoneOutlineRounded } from "@mui/icons-material";
import { Box, Button, CircularProgress, Paper } from "@mui/material";
import { getToken } from "auth/authenticate";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const PaymentSuccess = () => {
  const aptId = useParams()?.aptId || null;
    const [appointmentData , setAppointmentData ] = useState([]);
    const [userData , setuserData ] = useState([]);
    const [patientId , setPatientId ] = useState('');
    const [isAptPaid , setIsAptPaid ] = useState('');
    const [isLoading , setIsLoading ] = useState(false);
  const navigate = useNavigate();


// useEffect(() => {
//     getAppointmentData();
    
//     if (appointmentData) {
//         fetchUserData();
//     }
//     if (userData) {
//         checkWeatherPaid();
//     }
// },[aptId])

// useEffect(() => {
//   getAppointmentData();
// }, [aptId]);

// useEffect(() => {
//   if (appointmentData) {
//     fetchUserData();
//   }
// }, [appointmentData]);

// useEffect(() => {
//   if (userData) {
//     checkWeatherPaid();
//   }
// }, [userData]);

useEffect(() => {
  setIsLoading(true);

  const fetchData = async () => {

    try {
      // Get appointment data
      const aptResp = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}appointment/${aptId}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const aptData = aptResp?.data?.data[0];
      setAppointmentData(aptData);
      if (!aptData?.patientId) {
        throw new Error("Patient ID not found in appointment data.");
      }

      setPatientId(aptData.patientId);

      // Fetch user data
      const userResp = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}user/patient/${aptData.patientId}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const userData = userResp?.data?.data;
      setuserData(userData);

      // Check payment status
      const paymentResp = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}payment/payment-status/${aptId}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const paymentData = paymentResp?.data?.data;

      if (paymentData) {
        const successPayments = Object.values(paymentData).filter(
          (row) => row.txnStatus === "SUCCESS"
        );

        if (successPayments.length > 0) {
          setIsAptPaid(successPayments[successPayments.length - 1].txnStatus);
        } else {
          setIsAptPaid("PENDING");
        }
      } else {
        setIsAptPaid("PENDING");
      }
    } catch (error) {
      console.error("Error in fetching data: ", error);
      alert(error.message || "An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (aptId) {
    fetchData();
  }
}, [aptId]);



// const getAppointmentData = async () => {
//     setIsLoading(true);
//     try {
//         const resp = await axios.get(
//           `${process.env.REACT_APP_BACKEND_URL}appointment/${aptId}`,
//           {
//             headers: { Authorization: `Bearer ${getToken()}` },
//           }
//         );
//         console.log("user data response: ", JSON.stringify(resp?.data?.data));
//         setAppointmentData(resp?.data?.data[0]);
//         console.log('appointment data : ', resp?.data?.data[0]);
//         setPatientId(resp?.data?.data[0].patientId);
//         alert('apt : '+ JSON.stringify(appointmentData));
//         setIsLoading(false);
//       } catch (error) {
//         console.log(error);
//         setIsLoading(false);
//       }
// }

//   const fetchUserData = async () => {
//     setIsLoading(true);
//     if (!patientId) {
//         alert('patient id not found!');
//         setIsLoading(false);
//         return console.error('Error');

//     } else {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}user/patient/${patientId}`,
//         {
//           headers: { Authorization: `Bearer ${getToken()}` },
//         }
//       );
//       console.log("user data response: ", JSON.stringify(response?.data?.data));
//       setuserData(response?.data?.data);
//       setIsLoading(false);

//     } catch (error) {
//       console.log(error);
//       setIsLoading(false);

//     }
// }
//   };

  // check if appointment has paid successfull. if success, neglect the payment process.
  // -------------- working code ---------------
  // const checkWeatherPaid = async () => {
  //   setIsLoading(true);

  //   if (!aptId) {
  //     console.log("No appointment ID provided.");
  //     setIsLoading(false);

  //     return;
  //   }
  //   try {
      // const res = await axios.get(
      //   `${process.env.REACT_APP_BACKEND_URL}payment/payment-status/${aptId}`,
      //   {
      //     headers: { Authorization: `Bearer ${getToken()}` },
      //   }
      // );
  //     console.log(
  //       "appointment payment data response: ",
  //       JSON.stringify(res?.data.data)
  //     );
  //     setIsAptPaid(res?.data.data[0].txnStatus);
  //     setIsLoading(false);

  //   } catch (error) {
  //     console.log(error);
  //     setIsLoading(false);

  //   }
  // };

  // ------------- improved --------------
  // const checkWeatherPaid = async () => {
  //   setIsLoading(true);
  
  //   if (!aptId) {
  //     console.log("No appointment ID provided.");
  //     setIsLoading(false);
  //     return;
  //   }
  
  //   try {
  //     const res = await axios.get(
  //       `${process.env.REACT_APP_BACKEND_URL}payment/payment-status/${aptId}`,
  //       {
  //         headers: { Authorization: `Bearer ${getToken()}` },
  //       }
  //     );
  
  //     console.log(
  //       "appointment payment data response: ",
  //       JSON.stringify(res?.data.data)
  //     );
  
  //     const paymentData = res?.data?.data; 

  
  //     if (!paymentData) {
  //       console.log("No payment data found.");
  //       setIsLoading(false);
  //       return;
  //     }
  
  //     // Convert the payment data object to an array of rows
  //     const paymentArray = Object.values(paymentData);
  
  //     // Filter rows with txnStatus === "SUCCESS"
  //     const successPayments = paymentArray.filter(
  //       (row) => row.txnStatus === "SUCCESS"
  //     );
  
  //     let successPayment = null;
  
  //     if (successPayments.length > 0) {
  //       // Pick the first SUCCESS row
  //       // successPayment = successPayments[0];
  
  //       // Alternatively, to pick the last SUCCESS row:
  //       successPayment = successPayments[successPayments.length - 1];
  
  //       console.log("User can proceed with:", successPayment);
  
  //       // Set the first successPayment txnStatus
  //       setIsAptPaid(successPayment.txnStatus);
  //     } else {
  //       console.log("No SUCCESS payment found. User cannot proceed.");
  //       setIsAptPaid("PENDING");
  //     }
  
  //     setIsLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching payment status:", error);
  //     setIsLoading(false);
  //   }
  // };
  

const handleProceed = async () => {

    // alert('paid? : '+ isAptPaid);
    if (isAptPaid === "SUCCESS") {

        navigate("/apt-external/join-consultation/", {
            state: {
              secretData: { appointmentData, userData },
            },
          });
    
    } else if (isAptPaid === "PENDING") {
        alert('Payment is still pending. Try again. If you are not sure, contact for support');
    } else if (isAptPaid === "FAILED") {
        alert("Payment is not complete. Please verify that your payment has done correct.")
    } else {
        alert ('There is something wrong!');
    }
}

  return (
    <>
      <Box pt={10} pl={5} pr={5}>
        <Paper elevation={3} sx={{ padding: "1rem" }}>

          <div>
            {isLoading && (
              <CircularProgress />
            )}
          </div>
          <div>
            <span>
              <DoneOutlineRounded
                sx={{
                  color: "rgb(4, 206, 122)",
                  border: "1px solid rgb(4, 206, 122)",
                  borderRadius: "50%",
                  padding: "5px",
                }}
              />
            </span>{" "}
            <h1 style={{ fontWeight: "normal" }}>Payment Success</h1>
            <p>Appointment ID: {aptId}</p>
            {/* <p>Order Transaction: {ordTr}</p>
      <p>User Data: {usrD}</p> */}
      
          </div>
          <div>
            <Button onClick={() => handleProceed()}>Proceed to Waiting Room</Button>
          </div>
        </Paper>
      </Box>
    </>
  );
};

export default PaymentSuccess;
